import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Color, CommonProperties } from '../styles';
import BaseText from './BaseText';

const FormLabel = ({ label, required, smallText }) => {
  return (
    <View style={styles.labelContainer}>
      <BaseText style={styles.labelText}>{label}</BaseText>
      {required && <BaseText style={styles.required}>*</BaseText>}
      {smallText && <BaseText style={styles.small}>{smallText}</BaseText>}
    </View>
  );
};

const styles = StyleSheet.create({
  labelText: {
    color: Color.text.high,
    ...CommonProperties.mr2,
  },
  labelContainer: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  required: {
    fontWeight: 'bold',
    color: Color.required,
    ...CommonProperties.small,
    ...CommonProperties.mr2,
  },
  small: {
    fontWeight: '100',
    color: '#444',
    ...CommonProperties.small,
  },
});

export default FormLabel;
